import { createAsyncThunk } from '@reduxjs/toolkit';
import { LogType, Logger } from '@hitiq/logger';
import { takeWhile, tap } from 'rxjs';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';

// This type describes the error object structure:
type SyncError = {
  message: string;
};

type SyncPayload = {
  logger: Logger;
  amplifyDataStore: AmplifyDataStore<any>;
};

export const syncThunk = createAsyncThunk<
  boolean,
  SyncPayload,
  { rejectValue: SyncError }
>(
  'auth/syncThunk',
  async (
    payload,
    thunkApi,
    // TODO: figure out return type of rejectWithValue something like RejectWithValue<Alert>
  ) => {
    const { amplifyDataStore, logger } = payload;
    // console.log('syncThunk: ');
    try {
      const result = await amplifyDataStore.startSync();
      if (!result.success) {
        // QUESTION: what do we do if startSync fails?
      }

      return await new Promise((resolve, reject) => {
        amplifyDataStore.onIsSyncedChanged
          // WARNING: this might cause a memory leak on hot reload since it never returns true
          .pipe(takeWhile((value) => value === false, true))
          .subscribe((isSynced: boolean) => {
            // console.log('isSynced: ', isSynced);
            if (!isSynced) {
              return;
            }
            logger.log(
              LogType.debug,
              `Datastore: onIsSyncedChanged isSynced === true`,
            );

            // TODO: change to dispatchSyncCompleted() to use event as a use case rather then a setter.
            // this.dispatchUpdateIsSyncCompleted(true);
            // this.amplifyDataStore.startObservingDataEvents();
            // this.setupStore();
            resolve(true);
          });
      });
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: 'Sync failed.',
      });
    }
  },
);
